import './styles/base.css';
import { RouterWrapper } from "./pages/index.jsx";
import { RouterProvider } from "react-router-dom";
import React from 'react';
import { useConfig } from './context/ConfigContext.js';
import { CategoriaProvider } from './components/CategoriaContext.jsx';
import { ClienteProvider } from './context/ClienteContext.jsx';
import Modal from 'react-modal';

function App({ logo, backgroundCatalog }) {
  const config = useConfig();

  if (typeof window !== 'undefined') {
    window.storeLogo = logo;
    window.storeBackgroundCatalog = backgroundCatalog;
  }

  Modal.setAppElement('#root');

  return (
    <ClienteProvider>
      <CategoriaProvider>
        <RouterProvider router={RouterWrapper(logo, backgroundCatalog, config)} />
      </CategoriaProvider>
    </ClienteProvider>
  );
}

export default App; 